import React from 'react';
import { registerWidget } from '@okapi/core';
import { SpecialOfferProps } from 'remotes/special-offer';
import { State } from 'store/types';
import { SpecialOfferRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, SpecialOfferProps>(`${__NAME__}/special-offer`, state => {
  const store = initWidgetData(state);

  return remoteProps => <SpecialOfferRemote store={store} {...remoteProps} />;
});
